import ko from '@tko/build.knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import Vue from 'vue';
import Rx from '../../thirdPartyForks/rx.all';
import DateRangeDataService from './date-range-picker.service';
import DateRangeHelperService from './date-range-picker.helper-service';
import DataProvider from '../../app/data-framework/data-provider';
import template from 'raw-loader!./dialBackInput.ko.html';
import DialBackInput from './dialBackInput.vue'
import LoginService from "../../services/login.service";

/**
 * New date rang picker for Monitoring but leaving old picker for analytics.
 * This is the knockout shim until we fully swith to vue.
 */

const PLAY_BUTTON_TYPE = 'play';
const PAUSE_BUTTON_TYPE = 'pause';
const BACK_BUTTON_TYPE = 'back';
const FORWARD_BUTTON_TYPE = 'forward';
var INTERVAL_BETWEEN_UPDATES_IN_MS = 60 * 1000;  // 1 minute - 'production' value

function DialBackInputWrapper(params) {
    var self = this;
    self.initialize(params);
}

DialBackInputWrapper.prototype = {
    setNewDateRange(newDateRange) {
      let self = this;
      self.dateRangeService.setCurrentRange(newDateRange);
      self.vueDialBack.dateRange = self.dateRangeModel.getCurrentRange();
    },
    // knockout called initialize function
    initialize: function (params) {
        var self = this;
        self.DIAL_BACK_HOURS = LoginService.userObject.cpmmDialBackHours;
        self.dateRangeHelperService = new DateRangeHelperService(self.DIAL_BACK_HOURS);

        self.showDownsampling = params.showDownsampling;

        self.DIRECTION_BACKWARD = self.dateRangeHelperService.MOVE_DIRECTION.BACKWARD;
        self.DIRECTION_FORWARD = self.dateRangeHelperService.MOVE_DIRECTION.FORWARD;

        self.dateRangeModel = params?.dateRangeModel?.();
        self.dateRangeService = _.get(params, 'dateRangeService', new DateRangeDataService(self.dateRangeModel));
        self.isLiveMode = _.get(params, 'isLiveMode', ko.observable(self.dateRangeService.getLiveModeStatus()));

        self.dateRangeService.setAvailableRanges(self.dateRangeHelperService.getDefaultRanges());

        self.formattedRange = ko.observable();
        self.formattedDuration = ko.observable();
        self.isMoveRangeBackwardEnabled = ko.observable(self.isTimeRangeEnabled(self.DIRECTION_BACKWARD));
        self.isMoveRangeForwardEnabled = ko.observable(self.isTimeRangeEnabled(self.DIRECTION_FORWARD));

        self.statusModeLegendStyle = ko.pureComputed(function () {
            return ko.unwrap(self.isLiveMode) ? 'live-mode-on-legend' : 'live-mode-off-legend';
        });

        self.statusModeLegendText = ko.pureComputed(function () {
            return 'LIVE: ' + (ko.unwrap(self.isLiveMode) ? 'ON' : 'OFF');
        });

        self.dateRange = {
          startDate: undefined,
          endDate: undefined
        };

        self.dateRangeModel.liveModeStatusUpdated.add(self.liveModeStatusUpdated.bind(self));

        //  Updates 'start' and 'end' date-times each 'INTERVAL_BETWEEN_UPDATES_IN_MS' if live mode is enabled
        self.timerObservable = Rx.Observable
            .timer(INTERVAL_BETWEEN_UPDATES_IN_MS, INTERVAL_BETWEEN_UPDATES_IN_MS)
            .subscribe(function () {
                if (self.dateRangeService.getLiveModeStatus()) {
                    self.updateLiveTimes();
                }
            });

        setTimeout(function(){
          function mediaButtonHandler(buttonType) {
            switch (buttonType) {
                case PLAY_BUTTON_TYPE:
                    self.toggleLiveMode();
                    break;
                case PAUSE_BUTTON_TYPE:
                    self.toggleLiveMode();
                    break;
                case BACK_BUTTON_TYPE:
                    self.moveRangeBackward();
                    break;
                case FORWARD_BUTTON_TYPE:
                    self.moveRangeForward();
                    break;
                default:
                    console.warn('unrecognized button type', buttonType);
                    break;
            }
          }
          function dateRangeHandler(newDateRange) {
            let isLive = self.dateRangeService.getLiveModeStatus();
            if (newDateRange.isLive && !isLive || !newDateRange.isLive && isLive) {
              self.toggleLiveMode();
            }
            self.setNewDateRange(newDateRange);
          }

          self.vueDialBack = new Vue({
              el: '#vueDialBack',
              data: {
                  dateRange: self.dateRangeModel.getCurrentRange(),
                  dateRangeHandler: dateRangeHandler,
                  dialBackHours: self.DIAL_BACK_HOURS,
                  isBackDisabled: !self.isMoveRangeBackwardEnabled(),
                  isForwardDisabled: !self.isMoveRangeForwardEnabled(),
                  isLive: self.isLiveMode(),
                  mediaButtonHandler: mediaButtonHandler,
                  showDownsampling: self.showDownsampling,
              },
              render(h) {
                  return h(DialBackInput, {
                      props: {
                          dateRangeHandler: this.dateRangeHandler,
                          isBackDisabled: this.isBackDisabled,
                          isForwardDisabled: this.isForwardDisabled,
                          isLive: this.isLive,
                          isPaused: !this.isLive,
                          dateRange: this.dateRange,
                          dialBackHours: this.dialBackHours,
                          showDownsampling: this.showDownsampling,
                      },
                      on: {
                          'media-button-pressed': this.mediaButtonHandler,
                      }
                  });
              }
          });
          self.backwardSubscription = self.isMoveRangeBackwardEnabled.subscribe(function(val) { self.vueDialBack.isBackDisabled = !val; });
          self.forwardSubscription = self.isMoveRangeForwardEnabled.subscribe(function(val) { self.vueDialBack.isForwardDisabled = !val; });
          self.isLiveSubscription = self.isLiveMode.subscribe(function(val) { self.vueDialBack.isLive = !!val; }) // double bang to ensure this is a boolean value
        }, 1);
    },

    updateLiveTimes: function() {
        var self = this;
        var isLiveMode = self.dateRangeService.getLiveModeStatus();
        var currentRange = self.dateRangeService.getCurrentRange();

        if (isLiveMode) {
            var newRange = getClosestRange(currentRange);
            var newLabel = self.dateRangeHelperService.getFormattedDuration(newRange, isLiveMode);
            self.setNewDateRange({
                startDate: newRange.startDate,
                endDate: newRange.endDate,
                rangeLabel: newLabel
            });
        }
    },

    dispose: function () {
        var self = this;
        self.dateRangeModel.availableRangesUpdated.removeAll();
        self.dateRangeModel.liveModeStatusUpdated.removeAll();
        self.timerObservable.dispose();
        if (self.backwardSubscription) {
            self.backwardSubscription.dispose();
        }
        self.forwardSubscription.dispose();
        self.isLiveSubscription.dispose();
        if (self.vueDialBack) {
            self.vueDialBack.$destroy();
            self.vueDialBack.$el.parentNode.removeChild(self.vueDialBack.$el);
        }
    },

    isTimeRangeEnabled: function (direction) {
        var self = this;
        return self.isLiveMode() ? false : self.dateRangeHelperService.isNextRangeValid(self.dateRangeService.getCurrentRange(), direction);
    },

    liveModeStatusUpdated: function () {
        var self = this;
        var isLiveMode = self.dateRangeService.getLiveModeStatus();
        self.isLiveMode(isLiveMode);

        var currentRange = self.dateRangeService.getCurrentRange();
        if (!_.isEmpty(currentRange)) {
            var dialBackHours = self.dateRangeHelperService.getRoundedHourDifference(currentRange.startDate);
            DataProvider.getInstance().logActivity2('CPMMDialBackHours', 'Date Range Picker', dialBackHours);
        }
    },

    moveRangeBackward: function () {
        var self = this;
        if (self.isTimeRangeEnabled(self.DIRECTION_BACKWARD)) {
            var currentRange = self.dateRangeService.getCurrentRange();
            var updatedRange =
                self.dateRangeHelperService.moveTimeRange(currentRange, self.DIRECTION_BACKWARD);
            self.setNewDateRange(updatedRange);

            var isLiveMode = self.dateRangeService.getLiveModeStatus();
            if (isLiveMode) {
                self.dateRangeService.setLiveModeStatus(false);
            }
        }
        self.isMoveRangeBackwardEnabled(self.isTimeRangeEnabled(self.DIRECTION_BACKWARD));
        self.isMoveRangeForwardEnabled(self.isTimeRangeEnabled(self.DIRECTION_FORWARD));
    },

    moveRangeForward: function () {
        var self = this;
        if (self.isTimeRangeEnabled(self.DIRECTION_FORWARD)) {
            var currentRange = self.dateRangeService.getCurrentRange();
            var updatedRange =
                self.dateRangeHelperService.moveTimeRange(currentRange, self.DIRECTION_FORWARD);
            self.setNewDateRange(updatedRange);

            var isLiveMode = self.dateRangeService.getLiveModeStatus();
            if (isLiveMode) {
                self.dateRangeService.setLiveModeStatus(false);
            }
        }
        self.isMoveRangeBackwardEnabled(self.isTimeRangeEnabled(self.DIRECTION_BACKWARD));
        self.isMoveRangeForwardEnabled(self.isTimeRangeEnabled(self.DIRECTION_FORWARD));
    },

    toggleLiveMode: function () {
        var self = this;
        var isLiveMode = !self.dateRangeService.getLiveModeStatus();
        self.dateRangeService.setLiveModeStatus(isLiveMode);

        var currentRange = self.dateRangeService.getCurrentRange();
        var isKnownRange = self.dateRangeHelperService.isValidRangeLabel(currentRange.rangeLabel);

        if (isKnownRange) {
            var duration = self.dateRangeHelperService.getDurationFromRange(currentRange);
            var newRange = self.dateRangeHelperService.getRangeFromNowByDuration(duration);
            self.setNewDateRange({
                startDate: newRange.startDate,
                endDate: newRange.endDate,
                rangeLabel: currentRange.rangeLabel
            });
        } else if (isLiveMode) {
            var newRange = getClosestRange(currentRange);
            var newLabel = self.dateRangeHelperService.getFormattedDuration(newRange, isLiveMode);
            self.setNewDateRange({
                startDate: newRange.startDate,
                endDate: newRange.endDate,
                rangeLabel: newLabel
            });
        }

        self.isMoveRangeBackwardEnabled(self.isTimeRangeEnabled(self.DIRECTION_BACKWARD));
        self.isMoveRangeForwardEnabled(self.isTimeRangeEnabled(self.DIRECTION_FORWARD));
    },

};

/**
 * Function to get the closest live range so this will return the closest range
 * we support shifted to the current time.
 */
function getClosestRange(dateRange, dialBackHours) {
  let endDate = dateRange.endDate;
  let rangeInHours = moment.duration(dateRange.endDate.diff(dateRange.startDate)).asHours();
  if (rangeInHours >= 720) {
    return {
      startDate: moment().subtract(720, 'hours'),
      endDate: moment()
    };
  }
  if (rangeInHours >= 240) {
    return {
      startDate: moment().subtract(240, 'hours'),
      endDate: moment()
    };
  }
  if (rangeInHours >= 120) {
    return {
      startDate: moment().subtract(120, 'hours'),
      endDate: moment()
    };
  }
  if (rangeInHours >= 24) {
    return {
      startDate: moment().subtract(24, 'hours'),
      endDate: moment()
    };
  }
  if (rangeInHours >= 4) {
    return {
      startDate: moment().subtract(4, 'hours'),
      endDate: moment()
    };
  }
  if (rangeInHours >= 1) {
    return {
      startDate: moment().subtract(1, 'hours'),
      endDate: moment()
    };
  }
  return {
    startDate: moment(),
    endDate: moment()
  };
}

export default DialBackInputWrapper;

// register with knockout
ko.components.register('dial-back-input-wrapper', { template: template, viewModel: DialBackInputWrapper });
